import { useMutation } from '@tanstack/react-query';
import type { AuthError } from '@kmgestao/supabase-client';

import { supabase } from '../../lib/supabase.js';
import type { ResetPasswordConfirmInput, ResetPasswordRequestInput } from './schemas.js';

/**
 * Passo 1 do reset: envia email com link que redireciona ao `/auth/callback`
 * e, depois, para `/reset/confirm`. O link é um código single-use PKCE.
 */
export function useRequestPasswordReset() {
  return useMutation<void, AuthError, ResetPasswordRequestInput>({
    mutationFn: async ({ email, captchaToken }) => {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/auth/callback?next=/reset/confirm`,
        captchaToken,
      });
      if (error) throw error;
    },
  });
}

/**
 * Passo 2 do reset: após o callback trocar `code` por sessão, usuário está
 * autenticado (aal1) e pode atualizar a senha via `updateUser`.
 */
export function useConfirmPasswordReset() {
  return useMutation<void, AuthError, ResetPasswordConfirmInput>({
    mutationFn: async ({ password }) => {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
    },
  });
}
